import * as React from 'react'

import { subscribeToReplyEvents } from '../utils/commentScoreSessionManager'

export const useReplySessionSync = (
  channelIds: string[],
  startSession: () => void,
  stopSession: () => void,
  incrementReplyCount: () => void,
): void => {
  React.useEffect(() => {
    const unsubscribe = subscribeToReplyEvents({
      onStart: (id) => channelIds.includes(id) && startSession(),
      onStop: (id) => channelIds.includes(id) && stopSession(),
      onReplyCountIncreased: (id) =>
        channelIds.includes(id) && incrementReplyCount(),
    })
    return unsubscribe
  }, [channelIds, startSession, stopSession, incrementReplyCount])
}
